import { inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { map, of } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../auth.service';

export const noAuthGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  // On the server, allow render — browser guard will re-check
  if (!isPlatformBrowser(platformId)) {
    return of(true);
  }

  return authService.checkAuthStatus().pipe(
    map(authenticated => {
      if (authenticated) {
        router.navigate(['/']);
        return false;
      }
      // Not logged in — allow access to /login, /signup, etc. via direct URL
      return true;
    })
  );
};
